import React from "react";
import "../HomeIndustries.css";
import { Link } from "react-router-dom";

import {
  FiArrowRight,
  FiBriefcase,
  FiCreditCard,
  FiShield,
  FiSmartphone,
  FiTrendingUp,
  FiHome,
} from "react-icons/fi";

const industries = [
  {
    icon: <FiHome />,
    title: "Banking",
    badge: "Enterprise Grade",
    description:
      "Empowering banks with secure digital transformation, compliance automation, transaction monitoring, and scalable financial technology solutions.",
    link: "/industries",
  },
  {
    icon: <FiBriefcase />,
    title: "NBFC",
    badge: "Compliance Ready",
    description:
      "Supporting Non-Banking Financial Companies with lending workflows, customer onboarding, risk management, and regulatory compliance services.",
    link: "/industries",
  },
  {
    icon: <FiCreditCard />,
    title: "Payment Providers",
    badge: "24×7 Monitoring",
    description:
      "Helping payment providers deliver secure payment processing, fraud prevention, reconciliation, and seamless transaction experiences.",
    link: "/industries",
  },
  {
    icon: <FiShield />,
    title: "Insurance",
    badge: "Fraud Prevention",
    description:
      "Improving insurance operations with identity verification, compliance management, fraud detection, and digital customer journeys.",
    link: "/industries",
  },
  {
    icon: <FiSmartphone />,
    title: "Digital Wallets",
    badge: "API Ready",
    description:
      "Building secure wallet ecosystems through API integration, authentication, transaction security, and scalable cloud infrastructure.",
    link: "/industries",
  },
  {
    icon: <FiTrendingUp />,
    title: "FinTech Startups",
    badge: "Growth Focused",
    description:
      "Helping fintech startups launch, scale, and innovate with modern technology, compliance support, cloud architecture, and expert consulting.",
    link: "/industries",
  },
];

const HomeIndustries = () => {
  return (
    <section className="home-industries">

      <div className="container">

        {/* =======================
              SECTION HEADING
        ======================== */}

        <div className="industries-heading">

          <span className="industries-tag">
            INDUSTRIES WE SERVE
          </span>

          <h2>
            Empowering Every Segment of
            <span> Digital Finance</span>
          </h2>

          <p>
            Saivari Fintech Private Limited partners with financial
            institutions across the ecosystem, delivering secure,
            scalable, and compliance-driven technology solutions that
            accelerate innovation and business growth.
          </p>

        </div>

        {/* =======================
              INDUSTRY GRID
        ======================== */}

        <div className="industries-grid">

          {industries.map((industry, index) => (

            <div
              className="industry-card"
              key={index}
            >

              <div className="industry-icon">
                {industry.icon}
              </div>

              <span className="industry-badge">
                {industry.badge}
              </span>

              <h3>{industry.title}</h3>

              <p>{industry.description}</p>

              {/* <a
                href={industry.link}
                className="industry-btn"
              >
                Learn More
                <FiArrowRight />
              </a> */}

            </div>

          ))}

        </div>

        {/* =======================
                BOTTOM CTA
        ======================== */}

        <div className="home-industries-cta">

          <div>

            <h3>
              Ready to Transform Your Financial Business?
            </h3>

            <p>
              Whether you're a bank, NBFC, payment provider, insurance
              company, or fintech startup, our experts are ready to help
              you build secure, compliant, and future-ready solutions.
            </p>

          </div>

          <div className="home-industries-actions">

            <a
              href="/contact"
              className="primary-industry-btn"
            >
              Contact Our Team
            </a>

            {/* <Link
              to="/services"
              className="secondary-industry-btn"
            >
              Explore Services
            </Link> */}

          </div>

        </div>

      </div>

    </section>
  );
};

export default HomeIndustries;